/* Noromega: veksler mellom engangskjøp og abonnement på kjøpsknappene */
document.addEventListener('change', function (event) {
  var choice = event.target.closest('[data-nm-plan-choice]');
  if (!choice) return;
  var form = choice.closest('form');
  var input = form && form.querySelector('[data-nm-plan-input]');
  if (!input) return;
  if (choice.value) {
    input.value = choice.value;
    input.disabled = false;
  } else {
    input.disabled = true;
  }
});
